@let userId = loggedInUserId | async;
@let comments = notReactedComments | async;

@if (userId && comments) {
  <div class="flex flex-col gap-2">
    @for (comment of comments; track comment.id) {
      <!--    <app-comment [comment]="comment" [loggedInUserId]="userId"></app-comment>-->

      <button
        class="bg-surface px-4 py-2 rounded-lg flex justify-between items-center font-normal text-fg-subtle"
        (click)="openCommentedEntity(comment)"
      >
        <div class="flex flex-col gap-1 items-start">
          <span class="text-sm font-medium text-fg-secondary">
            @switch (comment.data.parentEntity) {
              @case ('document') {
                Dokument
              }
              @case ('invoice') {
                Rechnung
              }
              @case ('project') {
                Projekt
              }
              @case ('customer') {
                Firma oder Person
              }
            }
          </span>

          <span class="py-2">{{ comment.data.commentText }}</span>
          <span class="text-fg-secondary text-[10px]">{{
            comment.data.creationDate | date: 'dd.MM.yyy HH:mm:ss'
          }}</span>
        </div>
        <app-ng-icon class="text-md text-fg-faint" name="heroChevronRight"></app-ng-icon>
      </button>
    }
  </div>
}
